/* FUKUI - store-wide motion (fx.js). Loaded from layout/theme.liquid after theme.js.

   One language on every template, set by the home hero:
     - headlines rise out of their baseline, line by line
     - the well mark draws itself
     - standalone photos are revealed by a curtain from the bottom
     - rules draw themselves from left to right
     - tiles and rows arrive one after another
     - the facts count up

   The page is cut into UNITS (a section, a page hero, the product buy box,
   the collection shop...).  Each unit is staged once, in drafting order:
     rule > eyebrow > headline lines > index > lead > photos > items > buttons
   Waiting elements are hidden with inline styles.  Every animation runs TO
   the element's natural state and is then cancelled, so nothing is left
   behind to fight hover transitions or the theme's own scripts. */
(function () {
  'use strict';
  var EASE = 'cubic-bezier(.2,.6,.25,1)', CURTAIN = 'cubic-bezier(.65,0,.2,1)', RISE = 'cubic-bezier(.2,.65,.2,1)';

  /* what gets staged as one piece */
  var UNITS = 'section.reg, .pg-hero, .crumbs, .pdp, .col-head, .catbar, .shop, .cart-wrap, .cd-empty, ' +
              '.wrap > .reg-head, .ct, .fq, .jtabs, .feat, .jlist, .jnews, .art, .sug-wrap, ' +
              '.template-search .grid, .template-list-collections .cats, .wl, .template-404 .wrap, ' +
              '.shopify-policy__container';
  /* head pieces, animated on their own */
  var EYEBROW = '.pg-hero > .mono, .buy > .reg, .col-head .mono, .crumbs';
  var HEADLINE = '.reg-head > h2, .pg-hero > h1, .buy > h1, .col-head h1, .template-404 h1, .shopify-policy__title h1, .cd-empty > b, .wrap > .reg-head > h2';
  var LEAD = '.reg-head .lead, .pg-hero > .lead, .buy > .sub, .col-head .desc, .col-head .meta, .wrap > .prose';
  /* photos that stand on their own get the curtain */
  var PHOTO = '.ph, .stage, .founder2 > .por';
  /* things that rise one after another */
  var ITEMS = '.facts > div, .cols > div, .cats > a, .trust > div, .reviews .grid > .r, .journal .list > a, ' +
              '.track > .card, .ugc > *, .well-story > div, #grid > *, .xsell > div, .grid > .pc, ' +
              '.process > *, .values > *, .catbar > *, .filters > *, .toolbar, .jtabs > *, .jlist > *, ' +
              '.fq-nav, .fq-body > *, .cart-lines > *, .cart-sum, .wl > *, .rel-art > a, ' +
              '.mats > *, .look .tabs > *, .look .pane, .thumbs > *, .buy > *, .col-head > div > *, ' +
              '.founder2 > :not(.por), .wellrow > *, .ct > *, .art > *, .cd-empty > *, .jnews > *, ' +
              '.feat > *, .sug-wrap > *, .shopify-policy__body, .template-404 .wrap > *, .mto-band';
  var STAGGER_CAP = 8;   /* items past this get their own observer */

  function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function visible(el) { return el.offsetWidth || el.offsetHeight; }
  function outermost(list) { return list.filter(function (t) { return !list.some(function (o) { return o !== t && o.contains(t); }); }); }
  function inside(el, list) { return list.some(function (o) { return o.contains(el); }); }

  /* -- hero: prepare the markup the CSS choreography needs -- */
  function prepHero() {
    var hero = document.querySelector('.hero');
    if (!hero) return false;
    if (!hero.classList.contains('fx-hero')) {   /* hero.liquid may already ship the class; this is the fallback */
      all(hero, '.h1 > span').forEach(function (s) { if (!s.querySelector('i')) s.innerHTML = '<i>' + s.innerHTML + '</i>'; });
      inlineWell(hero.querySelector('.h1 .well'));
      hero.classList.add('fx-hero');
    }
    return true;
  }

  /* <use href="#well"> cannot be animated stroke by stroke - copy the lines in */
  function inlineWell(svg) {
    if (!svg) return false;
    if (svg.querySelector('line')) return true;
    var use = svg.querySelector('use'), ref = use && (use.getAttribute('href') || use.getAttribute('xlink:href'));
    if (ref !== '#well') return false;
    var sym = document.getElementById('well');
    if (!sym) return false;
    svg.setAttribute('viewBox', sym.getAttribute('viewBox') || '0 0 24 24');
    svg.innerHTML = sym.innerHTML;
    return true;
  }

  /* run TO the natural state, then let go.  The end keyframe is spelled out
     in full: Safari ignores (older builds throw on) keyframes that leave a
     property implicit, which is how an animation turns into a plain jump. */
  var REST = { opacity: 1, transform: 'none', clipPath: 'inset(0 0 0 0)' };
  function play(el, from, opts) {
    el.style.opacity = ''; el.style.clipPath = ''; el.style.transform = '';
    var to = {};
    for (var k in from) to[k] = opts.to && opts.to[k] !== undefined ? opts.to[k] : REST[k];
    try {
      var a = el.animate([from, to], { duration: opts.d, delay: opts.t || 0, easing: opts.e || EASE, fill: 'backwards' });
      a.onfinish = function () { a.cancel(); };
      return a;
    } catch (e) { return null; }   /* no WAAPI: the element is simply shown */
  }
  function rise(el, t, d) { play(el, { opacity: 0, transform: 'translateY(22px)' }, { d: d || 750, t: t }); }
  function curtain(el, t) {
    var r = getComputedStyle(el).borderRadius || '0px';
    play(el, { clipPath: 'inset(100% 0 0 0 round ' + r + ')' }, { d: 1000, t: t, e: CURTAIN, to: { clipPath: 'inset(0 0 0 0 round ' + r + ')' } });
    var img = el.querySelector('img');
    if (img) play(img, { transform: 'scale(1.08)' }, { d: 1900, t: t, e: 'cubic-bezier(.2,.5,.3,1)', to: { transform: 'scale(1)' } });
  }

  /* -- the product gallery frame ------------------------------------------
     The stage is the one photo on the site that is a drawing board rather
     than a picture on a wall, so it arrives the way the register draws:
     the frame is ruled in first, the count is typed into the corner, and
     only then does the photograph settle into it.  A curtain here would
     have said "image loading"; this says "sheet prepared". */
  var SVGNS = 'http://www.w3.org/2000/svg';

  function frameWait(el) {
    var img = el.querySelector('img'), cnt = el.querySelector('.cnt'), nav = el.querySelector('.nav');
    el.style.borderColor = 'transparent';
    if (img) img.style.opacity = '0';
    if (cnt) { cnt.dataset.fxText = cnt.textContent; cnt.textContent = ''; }
    if (nav) nav.style.opacity = '0';
  }

  function frameEntry(el, t) {
    var img = el.querySelector('img'), cnt = el.querySelector('.cnt'), nav = el.querySelector('.nav');
    var w = el.offsetWidth, h = el.offsetHeight;
    var r = parseFloat(getComputedStyle(el).borderRadius) || 0;
    var per = 2 * (w + h);

    /* the rule is drawn on top of the real border, then handed over to it */
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'fx-frame');
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    var rect = document.createElementNS(SVGNS, 'rect');
    rect.setAttribute('x', '.5'); rect.setAttribute('y', '.5');
    rect.setAttribute('width', Math.max(0, w - 1)); rect.setAttribute('height', Math.max(0, h - 1));
    rect.setAttribute('rx', r); rect.setAttribute('fill', 'none');
    rect.setAttribute('stroke', 'currentColor'); rect.setAttribute('stroke-width', '1');
    /* start at the top left corner, run the way a hand would */
    rect.setAttribute('stroke-dasharray', per);
    rect.setAttribute('stroke-dashoffset', per);
    svg.appendChild(rect);
    el.appendChild(svg);

    play(rect, { strokeDashoffset: per + 'px' }, { d: 640, t: t, e: CURTAIN, to: { strokeDashoffset: '0px' } });

    /* the sheet is ruled; the photograph settles onto it */
    setTimeout(function () {
      el.style.borderColor = '';
      if (img) { img.style.opacity = ''; play(img, { opacity: 0, transform: 'scale(1.035)' }, { d: 720, t: 0 }); }
    }, t + 300);

    /* the count is typed, character by character, into the corner */
    if (cnt) {
      var text = cnt.dataset.fxText || '';
      delete cnt.dataset.fxText;
      text.split('').forEach(function (ch, i) {
        setTimeout(function () { cnt.textContent += ch; }, t + 520 + i * 45);
      });
    }
    if (nav) { nav.style.opacity = ''; play(nav, { opacity: 0, transform: 'translateY(6px)' }, { d: 500, t: t + 620, e: 'ease-out' }); }

    /* hand the frame back to the border and take the drawing away */
    setTimeout(function () {
      var out = play(svg, { opacity: 1 }, { d: 320, t: 0, to: { opacity: 0 } });
      var done = function () { if (svg.parentNode) svg.parentNode.removeChild(svg); };
      if (out) out.onfinish = done; else done();
      setTimeout(done, 400);
    }, t + 700);
  }

  /* +899 / 5.0 star / 113 - keep prefix/suffix, count the number */
  function countUp(el, delay) {
    var m = /^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/.exec(el.textContent.trim());
    /* only a lone figure counts: "+899", "5.0 star" - never "2-3 days" */
    if (!m || m[1].length > 2 || m[3].length > 2 || /\d/.test(m[3])) return;
    var pre = m[1], suf = m[3], raw = m[2], dec = (raw.split(/[.,]/)[1] || '').length, sep = raw.indexOf(',') > -1 ? ',' : '.';
    var target = parseFloat(raw.replace(',', '.')), start = null, DUR = 1300;
    el.classList.add('fx-num');
    function frame(now) {
      if (start === null) start = now;
      var p = Math.min(1, (now - start) / DUR); p = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (target * p).toFixed(dec).replace('.', sep) + suf;
      if (p < 1) requestAnimationFrame(frame);
    }
    el.textContent = pre + (0).toFixed(dec).replace('.', sep) + suf;
    setTimeout(function () { requestAnimationFrame(frame); }, delay);
  }

  /* split a headline into <br>-separated lines, each in its own clipping box */
  function splitLines(h) {
    if (!h || h.querySelector('.fx-l')) return h ? all(h, '.fx-l > i') : [];
    h.innerHTML = h.innerHTML.split(/<br\s*\/?>/i).map(function (l) { return '<span class="fx-l"><i>' + l.trim() + '</i></span>'; }).join('');
    return all(h, '.fx-l > i');
  }

  /* -- one unit -- */
  function stage(unit, extra) {
    var p = { eyebrow: null, lines: [], idx: null, leads: [], photos: [], frames: [], items: [], btns: [], nums: [], wells: [] };

    p.eyebrow = unit.matches(EYEBROW) ? unit : unit.querySelector(EYEBROW);
    var head = unit.matches(HEADLINE) ? unit : unit.querySelector(HEADLINE);
    p.lines = splitLines(head);
    p.idx = unit.querySelector('.reg-head .idx');
    p.leads = all(unit, LEAD);

    var items = outermost(all(unit, ITEMS).filter(visible));
    var headBits = [p.eyebrow, head, p.idx].concat(p.leads).filter(Boolean);
    items = items.filter(function (it) { return !headBits.some(function (h) { return it === h || it.contains(h); }); });

    p.wells = all(unit, 'svg.well, .big > svg, .sig svg, .template-404 .wrap > svg').filter(inlineWell);
    p.wells.forEach(function (w) { w.classList.add('fx-well'); });

    p.photos = all(unit, PHOTO).filter(visible).filter(function (ph) { return !inside(ph, items) && !inside(ph, p.wells); });
    p.photos = outermost(p.photos);
    items = items.filter(function (it) { return !inside(it, p.photos); });
    /* the gallery stage is drawn, not unveiled */
    p.frames = p.photos.filter(function (ph) { return ph.classList.contains('stage'); });
    p.photos = p.photos.filter(function (ph) { return p.frames.indexOf(ph) === -1; });

    p.items = items.slice(0, STAGGER_CAP);
    var overflow = items.slice(STAGGER_CAP);
    p.btns = all(unit, '.btn').filter(visible).filter(function (b) { return !inside(b, items) && !inside(b, headBits) && !inside(b, p.photos); });
    p.nums = all(unit, '.facts .v');

    if (unit.classList.contains('rule-top') || unit.classList.contains('band')) unit.classList.add('fx-rule');

    /* waiting state */
    if (p.eyebrow) p.eyebrow.style.opacity = '0';
    p.lines.forEach(function (l) { l.style.transform = 'translateY(110%)'; });
    if (p.idx) p.idx.style.opacity = '0';
    p.leads.forEach(function (l) { l.style.opacity = '0'; });
    p.photos.forEach(function (ph) { ph.style.clipPath = 'inset(100% 0 0 0)'; });
    p.frames.forEach(frameWait);
    p.items.forEach(function (t) { t.style.opacity = '0'; });
    p.btns.forEach(function (b) { b.style.opacity = '0'; });
    overflow.forEach(function (t) { t.style.opacity = '0'; extra(t, function () { rise(t, 0); }); });

    return function release(base) {
      base = base || 0;
      unit.classList.add('fx-on');
      if (p.eyebrow) play(p.eyebrow, { opacity: 0, transform: 'translateX(-10px)' }, { d: 700, t: base, e: 'ease-out' });
      p.lines.forEach(function (l, i) { play(l, { transform: 'translateY(110%)' }, { d: 900, t: base + 80 + i * 120, e: RISE }); });
      if (p.idx) play(p.idx, { opacity: 0, transform: 'translateX(14px)' }, { d: 700, t: base + 320, e: 'ease-out' });
      p.leads.forEach(function (l, i) { play(l, { opacity: 0, transform: 'translateY(10px)' }, { d: 700, t: base + 400 + i * 90, e: 'ease-out' }); });
      p.photos.forEach(function (ph, i) { curtain(ph, base + 260 + i * 140); });
      p.frames.forEach(function (fr, i) { frameEntry(fr, base + 200 + i * 140); });
      p.items.forEach(function (t, i) { rise(t, base + 340 + i * 90); });
      p.btns.forEach(function (b, i) { play(b, { opacity: 0, transform: 'translateY(8px)' }, { d: 600, t: base + 800 + i * 80, e: 'ease-out' }); });
      p.nums.forEach(function (n, i) { countUp(n, base + 420 + i * 90); });
      p.wells.forEach(function (w) { setTimeout(function () { w.classList.add('fx-on'); }, base + 500); });
    };
  }

  /* -- page -- */
  /* the layout adds .fx-pre to <html> before first paint so nothing shows
     before it is staged; it comes off here, or after 3 s if this never runs */
  function unveil() { document.documentElement.classList.remove('fx-pre'); }

  document.addEventListener('DOMContentLoaded', function () {
    if (reduced() || (window.Shopify && Shopify.designMode)) { unveil(); return; }
    var hasHero = prepHero();

    var main = document.getElementById('MainContent') || document.body;
    var units = outermost(all(main, UNITS).filter(visible).filter(function (u) { return !u.closest('.hero'); }));
    if (!('IntersectionObserver' in window)) { unveil(); return; }

    var lead = hasHero ? 1500 : 120, pending = new Map(), io;
    function watch(el, release) { pending.set(el, release); if (io) io.observe(el); }

    var plans = units.map(function (u) { return { el: u, release: stage(u, watch) }; });
    unveil();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var release = pending.get(en.target);
        if (release) { pending.delete(en.target); release(0); }
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
    pending.forEach(function (_, el) { io.observe(el); });

    plans.forEach(function (pl) {
      var top = pl.el.getBoundingClientRect().top;
      if (top < innerHeight * 0.85) pl.release(lead + Math.max(0, top - innerHeight * 0.25) * 0.35);
      else watch(pl.el, pl.release);
    });
    /* overflow items already on screen at load play with their unit */
    pending.forEach(function (release, el) {
      if (el.getBoundingClientRect().top < innerHeight * 0.85) { pending.delete(el); io.unobserve(el); release(lead + 500); }
    });

    /* find-in-page, anchors, restored scroll: never leave anything hidden */
    addEventListener('scroll', function sweep() {
      pending.forEach(function (release, el) {
        if (el.getBoundingClientRect().top < innerHeight) { pending.delete(el); io.unobserve(el); release(0); }
      });
    }, { passive: true });
  });
})();
